import { Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { LocationOnOutlined } from "@material-ui/icons";
import { CurrencyRupeeOutlined, PhoneOutlined } from "@mui/icons-material";
import Link from "next/link";
import React, { useState } from "react";
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    margin: "2.5rem 8rem",
    [theme.breakpoints.down("sm")]: {
      margin: "0 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "2rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  heading: {
    fontWeight: 600,
    color: "#0DB14B",
    fontSize: "2.125rem",
    lineHeight: "2.5rem",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  heading1: {
    fontWeight: 500,
    color: "#212121",
    fontSize: "1.75rem",
    lineHeight: "2.125rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
    },
  },
  subHeading1: {
    fontWeight: 400,
    color: "#212121",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
    },
  },
  cardLink: {
    textDecoration: "none !important",
    width: "100%",
    display: "block",
    color: "inherit",
    "&:hover": {
      textDecoration: "none !important",
    },
    "& > div": {
      textDecoration: "none !important",
    },
  },
  propertyCardContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "1rem",
    overflow: "hidden",
    boxShadow: "0px 4px 18px rgba(0,0,0,0.05)",
    // Remove the transition and hover effect
  },
  imageContainer: {
    position: "relative",
    width: "100%",
  },
  illustrationSizer: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    borderRadius: "1rem 1rem 0 0",
  },
  propertyTag: {
    position: "absolute",
    top: "1rem",
    left: "1rem",
    padding: "0.5rem 1rem",
    borderRadius: "8px",
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#FFFFFF",
    backgroundColor: "#00000080",
    zIndex: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.75rem",
      padding: "0.375rem 0.75rem",
    },
  },
  detailscontainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  detailsdiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1rem",
  },
  btnRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1rem",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  primaryButton: {
    padding: "0.5rem 1rem",
    background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    color: "#FFFFFF",
    fontSize: "1rem",
    fontWeight: "500",
    borderRadius: "0.75rem",
    textTransform: "none",
  },
  secondaryButton: {
    background: "#FFFFFF",
    color: "#0DB14B",
    border: "1px solid #0DB14B",
    padding: "0.5rem 1rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "none",
    borderRadius: "0.75rem",
    width: "100%",
  },
  propertiesdetailsdiv: {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    padding: "1rem",
    marginTop: "1rem",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "0.75rem",
    [theme.breakpoints.down("xs")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      margin: "0rem",
      gap: "0.5rem",
      padding: "0rem",
      //   boxShadow: "0px 4px 18px rgba(0,0,0,0.05)",
      margin: "1rem 0",
      border: "none",
    },
    // [theme.breakpoints.up("sm")]: {
    //   gap: "0.5rem",
    // },
  },
  iconTextRow: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    [theme.breakpoints.down("xs")]: {
      border: "1px solid rgba(0, 0, 0, 0.12)",
      //   boxShadow: "0px 4px 18px rgba(0,0,0,0.05)",
      borderRadius: "0.5rem",
      padding: "0.5rem",
      alignItems: "flex-start",
    },
  },
  detailLabel: {
    fontWeight: 400,
    fontSize: "0.875rem",
    color: "#666666",
  },
  detailValue: {
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#212121",
  },
  iconImage: {
    [theme.breakpoints.down("xs")]: {
      //   width: "30px",
      //   height: "30px",
      display: " none",
    },
  },
  iconTextContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    "& .MuiSvgIcon-root": {
      fontSize: "1.25rem",
      color: "#666666",
    },
  },
  divider: {
    width: "1px",
    height: "3rem",
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  cardsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "2rem",
    width: "100%",
    marginTop: "2rem",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      marginTop: "0rem",
    },
  },
}));

const Projects = () => {
  const classes = useStyles();

  const CONTACT_NUMBER = "08071844962";
  const [showNumbers, setShowNumbers] = useState({});

  const handleViewNumber = (propertyName) => {
    setShowNumbers((prev) => ({ ...prev, [propertyName]: true }));
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const properties = [
    {
      name: "Heavie Halcyon by Sentient",
      image: "images/icons/heavie/halcyoncard.webp",
      location: "HSR Layout, Bengaluru, Karnataka 560102",
      price: "5.4 Cr onwards",
      rera: "PRM/KA/RERA/1251/310/PR/131224/007286",
      href: "/halcyon",
      tag: "New Launch",
      details: [
        {
          icon: "/images/icons/heavie/singleproperty/project_type.svg",
          label: "Project Type",
          value: "Apartment",
        },
        {
          icon: "/images/icons/heavie/singleproperty/possesion_date.svg",
          label: "Possession Date",
          value: "Aug 2028",
        },
        {
          icon: "/images/icons/heavie/singleproperty/bedroom.svg",
          label: "Bedrooms",
          value: "3 BHK",
        },
        {
          icon: "/images/icons/heavie/singleproperty/unit_size.svg",
          label: "Unit Size",
          value: "2065 - 2357 Sft",
        },
      ],
    },
    {
      name: "Heavie Eden by Sentient",
      image: "images/icons/heavie/edencard.webp",
      location: "Kasavanahalli, Bengaluru, Karnataka 560035",
      price: "1.9 Cr onwards",
      rera: "PRM/KA/RERA/1251/446/PR/210222/004725",
      href: "/eden",
      tag: "Ready to move-in",
      details: [
        {
          icon: "/images/icons/heavie/singleproperty/project_type.svg",
          label: "Project Type",
          value: "Apartment",
        },
        {
          icon: "/images/icons/heavie/singleproperty/possesion_date.svg",
          label: "Possession Date",
          value: "August 2025",
        },
        {
          icon: "/images/icons/heavie/singleproperty/bedroom.svg",
          label: "Bedrooms",
          value: "2 BHK",
        },
        {
          icon: "/images/icons/heavie/singleproperty/unit_size.svg",
          label: "Unit Size",
          value: "1311 - 1542 Sft",
        },
      ],
    },
  ];

  return (
    <div className={classes.mainContainer}>
      <div className={classes.sectionContainer}>
        <div className={classes.text}>
          <Typography
            variant="h1"
            className={classes.heading}
          >
            Projects
          </Typography>
          <div className={classes.cardsContainer}>
            {properties.map((property) => (
              <Link
                href={property.href}
                className={classes.cardLink}
                key={property.name}
              >
                <div className={classes.propertyCardContainer}>
                  <div className={classes.imageContainer}>
                    {/* Use next/image if needed */}
                    <img
                      src={property.image}
                      alt={property.name}
                      className={classes.illustrationSizer}
                      loading="lazy"
                    />
                    {property.tag && <div className={classes.propertyTag}>{property.tag}</div>}
                  </div>
                  <div style={{ padding: "1rem 1rem", width: "100%" }}>
                    <div className={classes.detailscontainer}>
                      <div className={classes.detailsdiv}>
                        <Typography
                          variant="h2"
                          className={classes.heading1}
                        >
                          {property.name}
                        </Typography>
                        <div className={classes.iconTextContainer}>
                          <LocationOnOutlined />
                          <Typography className={classes.subHeading1}>{property.location}</Typography>
                        </div>
                        <div className={classes.iconTextContainer}>
                          <CurrencyRupeeOutlined />
                          <Typography className={classes.subHeading1}>{property.price}</Typography>
                        </div>
                        <div className={classes.iconTextContainer}>
                          <Typography className={classes.subHeading1}> {property.rera}</Typography>
                        </div>
                      </div>
                      <div
                        className={classes.btnRow}
                        onClick={handleButtonClick}
                      >
                        {!showNumbers[property.name] ? (
                          <Button
                            className={classes.primaryButton}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleViewNumber(property.name);
                            }}
                            startIcon={<PhoneOutlined />}
                          >
                            View Number
                          </Button>
                        ) : (
                          <Button
                            className={classes.primaryButton}
                            href={`tel:${CONTACT_NUMBER}`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              window.location.href = `tel:${CONTACT_NUMBER}`;
                            }}
                            startIcon={<PhoneOutlined />}
                          >
                            {CONTACT_NUMBER}
                          </Button>
                        )}
                        <Button
                          className={classes.secondaryButton}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            document.querySelector("#contactus")?.scrollIntoView({ behavior: "smooth" });
                          }}
                        >
                          Get callback
                        </Button>
                      </div>
                    </div>

                    <div className={classes.propertiesdetailsdiv}>
                      {property.details.map((detail, index) => (
                        <React.Fragment key={detail.label}>
                          <div className={classes.iconTextRow}>
                            <img
                              src={detail.icon}
                              alt={AppConfig.imageAltText}
                              loading="lazy"
                              className={classes.iconImage}
                              height={32}
                              width={32}
                            />
                            <div>
                              <Typography className={classes.detailLabel}>{detail.label}</Typography>
                              <Typography className={classes.detailValue}>{detail.value}</Typography>
                            </div>
                          </div>
                          {index < property.details.length - 1 && <div className={classes.divider} />}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
